import { Pipe, PipeTransform } from '@angular/core';

/**
 * AutoCapitalizePipe
 * ----------------------
 * Ce pipe permet de mettre en majuscule la première lettre de chaque phrase d'une chaîne de caractères.
 * Il divise la chaîne en phrases en utilisant le point suivi d'un espace comme séparateur,
 * puis met en majuscule la première lettre de chaque phrase avant de les recombiner en une seule chaîne.
 *
 * @example
 * // Utilisation dans un template
 * {{ 'bonjour. comment allez-vous?' | autoCapitalize }}
 * // Résultat: "Bonjour. Comment allez-vous?"
 *
 * @example
 * // Utilisation dans le TypeScript
 * this.pipe.transform('hello world. how are you?')
 * // Résultat: "Hello world. How are you?"
 */
@Pipe({
  name: 'autoCapitalize',
})
export class AutoCapitalizePipe implements PipeTransform {
  transform(text: string): string {
    let values: string[] = text.toLowerCase().split('. ');
    if (typeof text !== 'string')
      throw new Error('AutoCapitalizePipe: input must be a string');
    values.forEach((sentence: string, index: number) => {
      values[index] = sentence.charAt(0).toUpperCase() + sentence.slice(1);
    });
    return values.join('. ');
  }
}
